import React from "react";
import clsx from "clsx";

import { Text, View } from "../base";

type SectionProps = {
  title: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
};

export const Section = ({ title, actions, children }: SectionProps) => (
  <View className="flex flex-col gap-2">
    <View className="flex flex-row items-center justify-between">
      <Text className="text-xs font-medium uppercase tracking-wider text-gray-400 dark:text-gray-500">{title}</Text>
      {actions}
    </View>
    {children}
  </View>
);

type FieldProps = {
  label: string;
  children: React.ReactNode;
  mono?: boolean;
};

export const Field = ({ label, children, mono }: FieldProps) => (
  <View className="flex flex-row items-baseline gap-3">
    <Text className="w-32 shrink-0 text-xs text-gray-400 dark:text-gray-500">{label}</Text>
    <View className={clsx("min-w-0 flex-1 text-sm text-gray-900 dark:text-gray-100", mono && "font-mono text-xs break-all")}>{children}</View>
  </View>
);
